// @flow
/* eslint-disable react/display-name */

import * as React from 'react';
import escape from 'escape-html';
import IconLoader from './IconLoader';

const LEGACY_ICONS = [
  'bitbucket',
  'chevron-right',
  'circle',
  'close',
  'code',
  'database',
  'external',
  'eye',
  'eye-strikethrough',
  'git',
  'github',
  'gitlab',
  'graphql',
  'menu',
  'organization',
  'password',
  'permission-small-cross',
  'permission-small-tick',
  'placeholder',
  'plus',
  'plus-circle',
  'queues',
  'retry',
  'twitter',
  'unknown-user',
  'webhook'
];

const ALIASES = {
  "job-retries-report": "jobRetriesReport",
  "lock-circle": "permissions",
  "down-triangle": "downTriangle",
  "up-triangle": "upTriangle",
  "git": "repository",
  "emails": "emailSettings",
  "api-tokens": "accessTokens",
  "build-skipping": "buildSkipping",
  "connected-apps": "connectedApps",
  "notification-services": "notificationServices",
  "pipeline": "steps",
  "sso": "singleSignOn",
  "two-factor": "twoFactorAuthentication"
};

export type Props = {
  style?: Object,
  className?: string,
  icon: string,
  title?: string
};

export default function Icon(props: Props) {
  const style = {
    ...props.style,
    fill: "currentColor",
    verticalAlign: "middle"
  };

  const icon = ALIASES[props.icon] || props.icon;

  if (LEGACY_ICONS.includes(icon)) {
    return <LegacyIcon {...props} style={style} />;
  }

  return <NewIcon {...props} icon={icon} style={style} />;
}

const NewIcon = React.memo<Props>((props: Props) => {
  const IconComponent = IconLoader.load(IconLoader.types.component, props.icon);

  return (
    <IconComponent
      title={props.title}
      width="22px"
      height="22px"
      className={props.className}
      style={props.style}
      fill="currentColor"
    />
  );
});

const LegacyIcon = React.memo<Props>((props: Props) => {
  let icon = IconLoader.load(IconLoader.types.raw, props.icon);
  icon = (props.title ? `<title>${escape(props.title)}</title>` : '') + icon;

  return (
    <svg
      viewBox="0 0 22 22"
      width="22px"
      height="22px"
      className={props.className}
      style={props.style}
      dangerouslySetInnerHTML={{ __html: icon }}
    />
  );
});
